






























import Vue from "vue";
import Component from 'vue-class-component'
import {Getter} from 'vuex-class'
import {ExternalLinksSection} from '@/models/LobbyDataResponse.model'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'

@Component({})
export default class ExternalLinksSectionComponent extends Vue {

    @Getter("externalLinksSection", StoreNamespace.LOBBY) externalLinksSection!: ExternalLinksSection

    private readonly MAX_EXTERNAL_LINKS_IN_LOBBY = 5

    onMoreLinksClick(): void {
        this.$router.push({name: 'important-links'})
    }
}
